import { Button, ButtonProps } from 'antd';
import { cx } from '@emotion/css';

interface DefaultButtonProps extends ButtonProps {
  children: React.ReactNode;
}

export const DefaultButton = (props: DefaultButtonProps) => {
  const { children, className, ...restProps } = props;

  return (
    <Button
      className={cx(
        '!bg-[var(--fett-fill-300)] !border-none !text-[var(--fett-text-secondary)] hover:opacity-80',
        className,
      )}
      {...restProps}
    >
      {children}
    </Button>
  );
};
